import React from "react";
import "./Policy.css";

const Policy = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center" }}>Termeni și condiții</h1>
      <hr style={{ width: "100%", margin: "20px auto" }} />
      <p style={{ textAlign: "justify" }}>
        Bine ai venit pe site-ul Firu' Artei! Înainte de a te bucura de minunile
        noastre croșetate, te rugăm să parcurgi cu atenție următorii termeni și
        condiții. Folosirea acestui site implică acceptarea acestor reguli.
        Aceste prevederi se completează și cu Legea nr. 365/2002 privind
        comerțul electronic, republicată și modificată și cu OUG nr. 34/2014
        modificată privind drepturile consumatorilor în cadrul contractelor
        încheiate cu profesioniștii.
      </p>
      <hr style={{ width: "100%", margin: "20px auto" }} />
      <h2 style={{ textAlign: "left" }}>
        <b>1. Informații generale</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        1.1. Acest site este deținut și operat de Firu' Artei, o marcă dedicată
        creării și vânzării de produse croșetate manual.
        <br></br>
        <br></br>
        1.2. Ne rezervăm dreptul de a modifica sau actualiza acești termeni și
        condiții oricând. Modificările vor fi publicate pe site, iar continuarea
        utilizării acestuia va fi considerată acceptare tacită a noilor termeni.
        Site-ul www.firu-artei.ro este administrat de catre FIRU ARTEI S.R.L cu
        sediul în localitatea Livada, nr. 175, Judetul CLUJ, cod postal 407338,
        Romania, inregistrata la Oficiul Registrului Comertului sub nr.
        J2024021627000, Cod de Identificare Fiscala 50536359, Tel. 0742 634 112,
        email contact.firuartei@gmail.com
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>2. Proprietatea și drepturile de autor</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        Utilizarea conținutului site-ului www.firu-artei.ro – imagini, texte,
        grafice, simboluri, scripturi, programe și alte date – în alte scopuri
        decât cele personale, necomerciale, este interzisă fără consimțământul
        explicit și scris din partea FIRU ARTEI S.R.L. Încălcarea acestor
        drepturi va fi sancționată prin instanțele penale, conform legilor în
        vigoare. În cazul numelor de mărci înregistrate, utilizarea lor pe site
        nu constituie reclamă pentru compania respectivă.
        <br></br>
        <br></br>
        FIRU ARTEI S.R.L. își rezervă dreptul de a modifica conținutul și
        structura site-ului în orice moment, fără o notificare prealabilă.
        Întregul conținut al site-ului este protejat prin Legea drepturilor de
        autor, iar FIRU ARTEI S.R.L. deține toate drepturile asupra paginilor,
        conținutului și prezentării site-ului. Este interzisă copierea,
        modificarea, afișarea, distribuirea, transmiterea, publicarea,
        comercializarea, licențierea, crearea unor materiale derivate sau
        utilizarea conținutului în orice alt scop fără acordul scris al FIRU
        ARTEI S.R.L.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>3. Produse și comenzi</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        3.1. Produsele prezentate pe site sunt realizate manual, iar fiecare
        piesă este unicat. Pot exista mici variații în ceea ce privește
        culoarea, dimensiunile sau detaliile, ceea ce face parte din farmecul
        lucrului manual.
        <br></br>
        <br></br>
        3.2. Comanda se poate plasa prin intermediul site-ului, completând toate
        informațiile solicitate.
        <br></br>
        <br></br>
        3.3. Prețurile afișate pe site includ TVA, acolo unde este cazul, dar nu
        includ costurile de livrare, care vor fi adăugate în momentul
        finalizării comenzii.
        <br></br>
        <br></br>
        3.4. Ne rezervăm dreptul de a refuza o comandă în următoarele situații:
        <br></br>Produsele comandate nu sunt disponibile.
        <br></br>Informațiile furnizate de client sunt incomplete sau incorecte.
        <br></br>Există suspiciuni de fraudă sau activități neautorizate.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>4. Livrare</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        4.1 Livrarea se face prin curier rapid în termen de 10-14 zile
        lucrătoare de la confirmarea comenzii.
        <br></br>
        <br></br>
        4.2 Costurile de livrare sunt suportate de client, exceptând cazurile în
        care se specifică altfel (ex: promoții cu livrare gratuită).
        <br></br>
        <br></br>
        4.3 Firu' Artei nu poate fi responsabil pentru întârzierile cauzate de
        firma de curierat.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>5. Plăți, prețuri, facturare</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        5.1 Plățile se pot efectua prin transfer bancar.
        <br></br>
        <br></br>
        5.2 Toate tranzacțiile sunt procesate printr-un sistem securizat,
        garantând confidențialitatea datelor tale.
        <br></br>
        <br></br>
        5.3 Preturile sunt afisate pe pagina dedicata fiecarui produs, contin
        TVA si nu includ cheltuielile de livrare decat daca este specificat in
        mod expres acest aspect sau se ofera ca și bonus pentru comenzile mari.
        În cazul în care prețul nu este afișat, veți avea posibilitatea de a
        cere o oferta, iar un reprezentant vă comunica prețul în cel mai scurt
        timp posibil.
        <br></br>
        <br></br>
        5.4 Prețul produsului comandat este cel afișat la data plasării
        comenzii.
        <br></br>
        <br></br>
        5.5 Prețul imprimat pe factură este același cu cel transmis de operatori
        în momentul confirmării comenzii.
        <br></br>
        <br></br>
        5.6 Pe baza informațiilor deținute de Firu Artei S.R.L. și a celor
        furnizate de cumpărător va fi emisa o factura pentru bunurile livrate.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>6. Politica de retur</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        Pentru a solicita rambursarea, returnarea sau schimbul unei comenzi
        plasate pe www.firu-artei.ro, este necesar să contactați FIRU ARTEI
        S.R.L. prin e-mail la contact.firuartei@gmail.com sau telefonic la
        +40742634112 și să specificați motivul returului, datele de contact
        (nume, prenume, e-mail, telefon, oraș, adresă, cod poștal), denumirea
        produsului comandat, data preferată pentru ridicarea coletului și datele
        bancare (numele băncii, numele titularului și IBAN-ul). Solicitarea
        dumneavoastră va fi analizată, iar în termen de maxim 2 zile lucrătoare
        veți fi notificat prin e-mail cu privire la situația cererii.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>7. Confidențialitatea datelor cu caracter personal:</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        Orice informații cu caracter personal, cum ar fi numele, adresa, numărul
        de telefon sau adresa de e-mail pe care le furnizați pe site-ul, nostru
        prin e-mail sau prin alte mijloace vor fi tratate conform Termenilor și
        Condițiilor și conform legilor în vigoare. Orice alte comunicări sau
        materiale pe care le transmiteți pe acest site, cum ar fi întrebări,
        comentarii, sugestii sau alte mesaje similare, vor fi considerate ca
        fiind neconfidențiale și neprotejate de drepturile de proprietate
        intelectuală.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>8. Obligațiile cumpărătorului</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        8.1 Să furnizeze informații reale, corecte și actuale despre entitatea
        sa atunci cand acestea i se cer, în caz contrar există posibilitatea
        refuzării comenzilor.
        <br></br>
        <br></br>
        8.2 Să accepte soluționarea eventualelor probleme în termen de 30 de
        zile de la data sesizării acestora printr-un email adresat
        administratorului.
        <br></br>
        <br></br>
        8.3 Să accepte TERMENII SI CONDITIILE administratorului odată cu
        lansarea comenzilor și sa achite contravaloarea marfii prin metodele
        puse la dispoziție, la momentul transmiterii comenzii.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>9. Obligațiile vânzătorului</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        9.1 Să pună la dispoziția utilizatorilor gratuit informații profesionale
        cu privire la produsele si serviciile sale. Continutul publicat în
        magazinul virtual are caracter orientativ. Caracteristicile produselor
        si documentația tehnică aferentă acestora afișate pe site sunt puse la
        dispoziție de către producatori și furnizori. Imaginile produselor sunt
        afișate cu titlu de prezentare. În functie de lotul în care au fost
        fabricate, aspectul real al produsului poate diferi.
        <br></br>
        <br></br>
        9.2 Să contacteze clienții pentru confirmarea comenzilor, prin e-mail
        sau telefonic.
        <br></br>
        <br></br>
        9.3 Să livreze produsele în cel mult 30 zile de la confirmarea livrării.
        <br></br>
        <br></br>
        9.4 Să utilizeze datele personale colectate de la clienți/utilizatori în
        concordanță cu secțiunea `Confidențialitatea datelor cu caracter
        personal`, parte integrantă din TERMENI SI CONDIȚII.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>10. Litigii</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        TERMENII SI CONDITII GENERALE DE VANZARE se supun legislației române. In
        caz de litigiu, dacă rezolvarea pe cale amiabilă nu are efect dupa
        înregistrarea reclamației la sediul companiei, se va apela la instanță.
        FIRU ARTEI S.R.L. nu raspunde de prejudiciile cauzate fară culpa sa, de
        nefuncționarea magazinului online sau pentru cele rezultând din
        imposibilitatea accesării paginilor magazinului virtual ( ex: defecțiuni
        la reteaua de internet). Forța majoră exonerează de raspundere partea
        care o invocă.
      </p>
      <br></br>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Conform Regulamentului (UE) 2016/679 privind protecţia persoanelor
        fizice în ceea ce priveşte prelucrarea datelor cu caracter personal şi
        privind libera circulaţie a acestor date şi de abrogare a Directivei
        95/46/CE (Regulamentul general privind protecţia datelor) si a
        Legislației naționale incidente (Legea nr. 129 din 15 iunie 2018 pentru
        modificarea şi completarea Legii nr. 102/2005 privind înfiinţarea,
        organizarea şi funcţionarea Autorităţii Naţionale de Supraveghere a
        Prelucrării Datelor cu Caracter Personal, precum şi pentru abrogarea
        Legii nr. 677/2001 pentru protecţia persoanelor cu privire la
        prelucrarea datelor cu caracter personal şi libera circulaţie a acestor
        date și LEGE nr. 190 din 18 iulie 2018 privind măsuri de punere în
        aplicare a Regulamentului (UE) 2016/679 al Parlamentului European şi al
        Consiliului din 27 aprilie 2016 privind protecţia persoanelor fizice în
        ceea ce priveşte prelucrarea datelor cu caracter personal şi privind
        libera circulaţie a acestor date şi de abrogare a Directivei 95/46/CE
        (Regulamentul general privind protecţia datelor) ), beneficiați de
        dreptul de acces, de interventie gratuita asupra datelor, dreptul de a
        nu fi supus unei decizii individuale si dreptul de a va adresa
        justitiei. Totodata, aveti dreptul sa va opuneti prelucrarii datelor
        personale care va privesc si sa solicitati stergerea datelor*. Pentru
        exercitarea acestor drepturi, va puteti adresa cu o cerere scrisa,
        datata si semnata, transmisă online prin email la adresa
        contact.firuartei@gmail.com. De asemenea, va este recunoscut dreptul de
        a va adresa justitiei.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Prin plasarea unei comenzi acceptați prelucrarea următoarelor date în
        vederea emiterii unei facturi și a unui AWB de transport.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Datele stocate sunt următoarele:
        <br></br>Nume și prenume – în scopul facturării și eliberării AWB-ului
        de transport.
        <br></br>Număr de telefon – în scopul eliberării AWB-ului de transport
        și a comunicării dvs. cu compania nnoastră și compania care efectuează
        livrarea.
        <br></br>Adresă(strada, număr, bloc, apartament, sector/judet, cod
        postal) – în scopul facturării și eliberării AWB-ului de transport.
        <br></br>Adresă de email – în scopul comunicării informațiilor și
        detaliilor legate de comandă.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Datele dumneavoastra nu vor fi transferate nici unui operator extern.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Daca unele din datele despre dumneavoastra sunt incorecte sau doriti sa
        le modificati, va rugam sa ne informati cât mai curând posibil.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Dacă doriți ștergerea datelor dvs. din serverele noastre, vă rugăm să ne
        trimiteți un email în care să ne specificați acest lucru, iar noi ne
        luăm angajamentul ca în 7 zile să le ștergem.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Observații:
        <br></br>*orice persoana are dreptul de a se opune, pentru motive
        legitime, la prelucrarea datelor ce o privesc. Acest drept de opozitie
        poate fi exclus pentru anumite prelucrari prevazute de lege (de ex.:
        prelucrari efectuate de serviciile financiare si fiscale, de politie,
        justitie, securitate sociala). Prin urmare, aceasta mentiune nu poate
        figura daca prelucrarea are un caracter obligatoriu;
        <br></br>*orice persoana are, de asemenea, dreptul de a se opune, în mod
        gratuit si fara nici o justificare, la prelucrarea datelor sale
        personale în scopuri de marketing direct.
      </p>
      <br></br>
      <p style={{ textAlign: "justify" }}>
        Ne rezervăm dreptul de a actualiza și modifica periodic această Politică
        de Confidențialitate, pentru a reflecta orice modificări ale modului în
        care prelucrăm datele dumneavoastră cu caracter personal sau orice
        modificări ale cerințelor legale. În cazul oricărei astfel de
        modificări, vom afișa pe website-ul nostru versiunea modificată a
        Politicii de Confidențialitate, motiv pentru care va rugam sa verificati
        periodic continutul acestei Politici de Confidentialitate.
      </p>
      <hr style={{ width: "100%", margin: "20px auto" }} />
      <h1 style={{ textAlign: "center" }}>Politica de achiziție și livrare</h1>
      <hr style={{ width: "100%", margin: "20px auto" }} />
      <h2 style={{ textAlign: "left" }}>
        <b>POLITICA DE PLATĂ</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        Modalitatea de plată de pe site-ul www.firu-artei.ro este în avans prin
        transfer bancar (informațiile necesare vor fi primite printr-un email).
        <br></br>
        <br></br>
        Pentru a achiziționa produsul dorit, selectați-l și apoi apăsați butonul
        „Adaugă în coș”. Apoi navigați la „Coșul meu” apăsând pe iconița din
        colț dreapta sus. In pasul următor verificați cantitatea fiecărui produs
        din coș și introduceți un cod de cupon daca este cazul. Introduceți
        datele personale și selectați metoda de livrare dorită: prin curier sau
        ridicare personală. Vă rugăm să completați corect formularul de comandă
        și să specificați persoana fizică sau juridică pentru facturare și
        livrare. Adresa de e-mail este esențială, deoarece toate informațiile
        despre produsul/serviciul achiziționat vă vor fi transmise prin e-mail.
        După completarea acestor informații veți primi un mail cu detaliile de
        plată și statusul comenzii.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>POLITICA RETUR</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        Modalitatea de plată de pe site-ul www.firu-artei.ro este în avans prin
        transfer bancar (informațiile necesare vor fi primite printr-un email).
        <br></br>
        <br></br>
        Pentru a solicita rambursarea, returnarea sau schimbul unei comenzi
        plasate pe www.firu-artei.ro, este necesar să contactați FIRU ARTEI
        S.R.L. prin e-mail la contact.firuartei@gmail.com sau telefonic la
        +40742634112 și să specificați motivul returului, datele de contact
        (nume, prenume, e-mail, telefon, oraș, adresă, cod poștal), denumirea
        produsului comandat, data preferată pentru ridicarea coletului și datele
        bancare (numele băncii, numele titularului și IBAN-ul). Solicitarea
        dumneavoastră va fi analizată, iar în termen de maxim 2 zile lucrătoare
        veți fi notificat prin e-mail cu privire la situația cererii.
      </p>
      <h2 style={{ textAlign: "left" }}>
        <b>Ce condiții trebuie sa indeplineasca produsul returnat?</b>
      </h2>
      <p style={{ textAlign: "justify" }}>
        În cazul unui retur, produsele returnate trebuie să fie în aceeași stare
        în care au fost livrate, incluzând ambalajul original și toate
        documentele care le-au însoțit (cutii, etichete, instrucțiuni etc.), și
        să fie trimise în termen de cel mult 15 zile de la notificarea intenției
        de retragere din contract. Costurile de retur sunt suportate de client.
        <br></br>
        <br></br>
        Dacă produsul achiziționat de pe www.firu-artei.ro prezintă defecte sau
        uzură, vă rugăm să ne contactați prin e-mail la
        contact.firuartei@gmail.com sau telefonic.
        <br></br>
        <br></br>
        Rambursarea banilor se va face în termen de 30 de zile de la primirea
        coletului la sediul nostru.
        <br></br>
        <br></br>
        Suma returnată nu include costurile de transport, ci doar valoarea
        produsului achiziționat. Toate produsele returnate, pentru care se
        solicită returnarea integrală a sumei, trebuie să respecte condițiile
        menționate anterior.
      </p>
    </div>
  );
};

export default Policy;
